import { Emoji } from 'emoji-mart'
import React from 'react'

import VibeLogo from 'components/Tiles/Modes/LetsVibe/VibeLogo'
import { CLASS_NOTIFICATION_TYPES } from 'helpers/notification'

import {
    Container,
    Main,
    Type,
    MessageWrap,
    Message,
    Name,
    VibeBy,
    VibedTo,
    VibingWrapper,
    NotificationIcon,
} from './styles'

const getTruncatedMessage = msg =>
    msg.length > 50 ? `${msg.slice(0, 47)}...` : msg

const getText = (user, msg) => (
    <>
        <Name>{user}</Name>&nbsp;{getTruncatedMessage(msg)}
    </>
)

const getMessage = (type, data) => {
    const { user, msg, user_to } = data

    switch (type) {
        case CLASS_NOTIFICATION_TYPES.chat:
            return getText(user, msg)

        case CLASS_NOTIFICATION_TYPES.call_joined:
            return getText(user, 'joined')

        case CLASS_NOTIFICATION_TYPES.call_left:
            return getText(user, 'left')

        case CLASS_NOTIFICATION_TYPES.tada:
            return getText(user, 'is dancing')

        case CLASS_NOTIFICATION_TYPES.thinking_face:
            return getText(user, 'is confused')

        case CLASS_NOTIFICATION_TYPES.thumbsup:
            return getText(user, 'is okay')

        case CLASS_NOTIFICATION_TYPES.raised_hand_with_fingers_splayed:
            return getText(user, 'raised hand')

        case CLASS_NOTIFICATION_TYPES.note_upload:
            return getText(user, 'uploaded a note')

        case CLASS_NOTIFICATION_TYPES.default:
        case CLASS_NOTIFICATION_TYPES.error:
        case CLASS_NOTIFICATION_TYPES.success:
            return getTruncatedMessage(msg)

        case CLASS_NOTIFICATION_TYPES.vibing:
            return (
                <>
                    <VibeBy>{user}</VibeBy>
                    &nbsp; is vibing with &nbsp;
                    <VibedTo>{user_to}</VibedTo>
                </>
            )

        default:
            return getText(null, null)
    }
}

const getIcon = type => {
    switch (type) {
        case CLASS_NOTIFICATION_TYPES.chat:
            return <Emoji emoji={{ id: 'speech_balloon' }} size={25} />

        case CLASS_NOTIFICATION_TYPES.call_joined:
            return <NotificationIcon src="/assets/revamp/call-join.svg" />

        case CLASS_NOTIFICATION_TYPES.call_left:
            return <NotificationIcon src="/assets/revamp/call-end.svg" />

        case CLASS_NOTIFICATION_TYPES.note_upload:
            return <NotificationIcon src="/assets/page-facing-up.svg" />

        case CLASS_NOTIFICATION_TYPES.default:
        case CLASS_NOTIFICATION_TYPES.success:
            return <NotificationIcon src="/assets/toast-success.svg" />

        case CLASS_NOTIFICATION_TYPES.error:
            return <NotificationIcon src="/assets/toast-error.svg" />

        case CLASS_NOTIFICATION_TYPES.vibing:
            return (
                <VibingWrapper>
                    <VibeLogo />
                </VibingWrapper>
            )

        case CLASS_NOTIFICATION_TYPES.tada:
        case CLASS_NOTIFICATION_TYPES.thinking_face:
        case CLASS_NOTIFICATION_TYPES.thumbsup:
        case CLASS_NOTIFICATION_TYPES.raised_hand_with_fingers_splayed:
            return <Emoji emoji={{ id: type }} size={25} />

        default:
            return null
    }
}

const getContent = (type, data) => {
    const renderIcon = getIcon(type)
    const messageView = getMessage(type, data)

    return (
        <Main type={type}>
            <Type>{renderIcon}</Type>
            <MessageWrap>
                <Message>{messageView}</Message>
            </MessageWrap>
        </Main>
    )
}

const ClassNotification = props => {
    const { type, data } = props
    const content = getContent(type, data)

    return <Container>{content}</Container>
}

export default ClassNotification
